import React, { useState, useEffect } from 'react';
import ComposeNotification from './components/ComposeNotification';
import NotificationHistory from './components/NotificationHistory';
import NotificationModal from './components/NotificationModal';
import useMarketingAndNotificationStore from '@/stores/AdminStore/MarketingAndNotificationStore';
import { NotificationRecord } from '@/services/PagesServices/MarketingAndNotificationService';
import './MarketingAndNotification.css';

const MarketingAndNotification: React.FC = () => {
  const [activeTab, setActiveTab] = useState('compose');
  const [selectedNotification, setSelectedNotification] = useState<NotificationRecord | null>(null);
  const [showModal, setShowModal] = useState(false);

  const {
    audiences,
    notificationHistory,
    fetchAudiences,
    fetchNotificationHistory,
  } = useMarketingAndNotificationStore();

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'compose' && !audiences) {
      fetchAudiences();
    }
    if (activeTab === 'history' && !notificationHistory) {
      fetchNotificationHistory();
    }
  }, [activeTab, audiences, notificationHistory, fetchAudiences, fetchNotificationHistory]);

  const handleViewNotification = (notification: NotificationRecord) => {
    setSelectedNotification(notification);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedNotification(null);
  };

  return (
    <div className="admin-marketing-container">
      <div className="admin-marketing-breadcrumb">
        <span className="admin-marketing-breadcrumb-item">Tools</span>
        <span className="admin-marketing-breadcrumb-separator">›</span>
        <span className="admin-marketing-breadcrumb-item admin-marketing-breadcrumb-active">Marketing</span>
      </div>

      <div className="admin-marketing-header">
        <h1 className="admin-marketing-title">Tools</h1>
        <p className="admin-marketing-subtitle">Administrative utilities and system tools</p>
      </div>

      <div className="admin-marketing-tabs">
        <button
          className={`admin-marketing-tab ${activeTab === 'compose' ? 'admin-marketing-tab-active' : ''}`}
          onClick={() => setActiveTab('compose')}
        >
          Compose Notification
        </button>
        <button
          className={`admin-marketing-tab ${activeTab === 'history' ? 'admin-marketing-tab-active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          Notification History
        </button>
        <button
          className={`admin-marketing-tab ${activeTab === 'tags' ? 'admin-marketing-tab-active' : ''}`}
          onClick={() => setActiveTab('tags')}
        >
          Audience Tags
        </button>
      </div>

      {activeTab === 'compose' && (
        <div className="admin-marketing-content">
          <ComposeNotification />
        </div>
      )}

      {activeTab === 'history' && (
        <div className="admin-marketing-content">
          <NotificationHistory onViewNotification={handleViewNotification} />
        </div>
      )}

      {activeTab === 'tags' && (
        <div className="admin-marketing-content">
          <h2 className="admin-marketing-section-title">Audience Tags</h2>
          <p className="admin-marketing-section-subtitle">Manage and organize your audience segments</p>
          {/* Add Audience Tags content here */}
        </div>
      )}

      {showModal && (
        <NotificationModal
          notification={selectedNotification}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default MarketingAndNotification;
